import { gql } from '@apollo/client'

export default gql(`
    mutation deleteImageTypes($id: [ID]! $project: String) {
        deleteImageTypes(
            input: $id
            project: $project
        )
    }`
)
